module.exports = __webpack_public_path__ + "startpage-be63061f/A1-4df2870f96805ea1edf1241ed055644d.svg";